/**
 * Check if a field has validation errors
 * @param validationErrors - The validation errors object from vuelidate
 * @param fieldName - The field name to check (supports nested fields with dot notation)
 * @returns true if the field has errors, false otherwise
 */
export function hasFieldError(validationErrors: any, fieldName: string): boolean {
  const fieldNames = fieldName.split('.');
  let result = validationErrors && validationErrors.value 
    ? validationErrors.value 
    : {};

  for (let i = 0; i < fieldNames.length; i++) {
    const fn = fieldNames[i];
    if (Object.prototype.hasOwnProperty.call(result, fn)) {
      result = result[fn];
    } else {
      return false;
    }
  }

  return result && result.$errors && result.$errors.length > 0;
}
